var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1334_2373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 74
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1334_2373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.683 38.1859H29.0548V32.0193H32.8497C33.5257 32.0193 34.09 31.7929 34.5426 31.3403C34.9952 30.8877 35.2215 30.3234 35.2215 29.6474V25.8526C35.2215 25.1766 34.9952 24.6123 34.5426 24.1597C34.09 23.7071 33.5257 23.4807 32.8497 23.4807H26.683V38.1859ZM29.0548 29.6474V25.8526H32.8497V29.6474H29.0548ZM38.4234 38.1859H44.3529C45.0289 38.1859 45.5932 37.9596 46.0457 37.507C46.4984 37.0543 46.7247 36.49 46.7247 35.8141V25.8526C46.7247 25.1766 46.4984 24.6123 46.0457 24.1597C45.5932 23.7071 45.0289 23.4807 44.3529 23.4807H38.4234V38.1859ZM40.7952 35.8141V25.8526H44.3529V35.8141H40.7952ZM50.5196 38.1859H52.8914V32.0193H57.1606V29.6474H52.8914V25.8526H57.1606V23.4807H50.5196V38.1859ZM25.0227 52.4167C23.6036 52.4167 22.4187 51.9413 21.468 50.9906C20.5173 50.0399 20.042 48.855 20.042 47.4359V14.2307C20.042 12.8116 20.5173 11.6267 21.468 10.676C22.4187 9.72535 23.6036 9.25 25.0227 9.25H58.2279C59.647 9.25 60.8319 9.72535 61.7826 10.676C62.7333 11.6267 63.2087 12.8116 63.2087 14.2307V47.4359C63.2087 48.855 62.7333 50.0399 61.7826 50.9906C60.8319 51.9413 59.647 52.4167 58.2279 52.4167H25.0227ZM25.0227 49.3333H58.2279C58.7023 49.3333 59.1371 49.1357 59.5324 48.7404C59.9277 48.3451 60.1253 47.9103 60.1253 47.4359V14.2307C60.1253 13.7564 59.9277 13.3216 59.5324 12.9263C59.1371 12.531 58.7023 12.3333 58.2279 12.3333H25.0227C24.5484 12.3333 24.1136 12.531 23.7183 12.9263C23.323 13.3216 23.1253 13.7564 23.1253 14.2307V47.4359C23.1253 47.9103 23.323 48.3451 23.7183 48.7404C24.1136 49.1357 24.5484 49.3333 25.0227 49.3333ZM15.7727 61.6667C14.3536 61.6667 13.1687 61.1913 12.218 60.2406C11.2673 59.2899 10.792 58.105 10.792 56.6859V20.3974H13.8753V56.6859C13.8753 57.1603 14.073 57.5951 14.4683 57.9904C14.8635 58.3857 15.2984 58.5833 15.7727 58.5833H52.0613V61.6667H15.7727Z",
    fill: "#AC772B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIc);
export default __webpack_public_path__ + "static/media/pdf_ic.3d77796d447a136300294c117d158919.svg";
export { ForwardRef as ReactComponent };